export default __webpack_public_path__ + "static/media/supplier.64ee8ab5.svg";